/*
 * @Author: wuhao
 * @Date: 2019-09-23 17:27:51
 * @LastEditors: lisf
 * @LastEditTime: 2020-12-11 20:14:16
 * @Description: 储存为sessionStorage
 */
import engine from 'store/src/store-engine'
import sessionStorage from 'store/storages/sessionStorage'

const storages = [sessionStorage]
const plugins = []

const sessionStore = engine.createStore(storages, plugins)

export default sessionStore



// WEBPACK FOOTER //
// ./src/utils/storage.js